import { useState } from "react";
import ReactPlayer from "react-player/youtube";
import {
  useGetLiveEventMessagesSubscription,
  useGetLiveEventQuery,
  useSendLiveEventMessageMutation,
} from "generated/graphql";
import dayjs from "dayjs";

function LiveSection({ liveEventId }: { liveEventId: string }) {
  const [message, setMessage] = useState("");
  const { data: liveEvent, loading: loadingLiveEvent } = useGetLiveEventQuery({
    variables: { live_event_id: liveEventId },
  });
  const { data, loading } = useGetLiveEventMessagesSubscription({
    variables: {
      live_event_id: liveEventId,
    },
  });
  const [
    sendLiveEventMessageMutation,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    { data: response, loading: sendingMessage, error: messageSendingErr },
  ] = useSendLiveEventMessageMutation();

  const submitMessage = () => {
    sendLiveEventMessageMutation({
      variables: {
        message,
        live_event_id: liveEventId,
      },
    });
    if (response) {
      setMessage("");
    }
  };

  return (
    <div id="liveSection" className="row">
      {!loadingLiveEvent && (
        <div className="live_column">
          <ReactPlayer
            url={liveEvent?.live_event?.stream_url!}
            height="100%"
            width="100%"
          />
        </div>
      )}
      <div
        className="chat_column"
        style={{ backgroundColor: "#1D2029", borderRadius: "10px" }}
      >
        {!loading &&
          data?.live_event_messages &&
          data?.live_event_messages.map((eventMessage) => (
            <div className="chat_container" key={`msg-${eventMessage.id}`}>
              <img
                src={eventMessage.senderDetails.avatar!}
                alt="Avatar"
                style={{ width: "100%" }}
                title={eventMessage.senderDetails.nickname!}
              />
              <p>{eventMessage.message}</p>
              <span className="time-right">
                {dayjs(eventMessage.created_at).format("H:mm:ss")}
              </span>
            </div>
          ))}
        {!loading && (
          <div className="chat_input">
            <img
              src="/images/profile5.jpg"
              alt="Avatar"
              style={{ width: "100%" }}
            />
            <input
              type="text"
              id="liveEventMesssage"
              name="liveEventMesssage"
              placeholder="Write your message..."
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              disabled={sendingMessage}
            />
            <button onClick={() => submitMessage()} disabled={sendingMessage}>
              {!sendingMessage && <>Send</>}
              {sendingMessage && <>...</>}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default LiveSection;
